import { ResolveFn } from '@angular/router'
import { inject } from '@angular/core'
import { PermissionsStore } from '@features/permissions/store/permissions.store'

export const marketableResolver: ResolveFn<boolean> = () => {
  const permissionsStore = inject(PermissionsStore)

  permissionsStore.fetchPermissions()

  return true
}
